"use client"

import * as React from "react"

type SmoothScrollOptions = ScrollIntoViewOptions

export function useSmoothScroll() {
  return React.useCallback(
    (targetId: string, options?: SmoothScrollOptions) => {
      if (!targetId) return
      const target = document.getElementById(targetId)
      if (target) {
        target.scrollIntoView({
          behavior: "smooth",
          block: "start",
          ...options,
        })
      }
    },
    []
  )
}
